import './listHeader.scss';
import colors from '../../../assets/scss/variable/color.scss';
import React, {Component} from 'react';
import T from "../../../shared/component/t/T";
import Storage from "../../../helpers/Storage";
import { ReportStatusTranslatable } from "../../../core/constants/ReportStatus";
import {admittedFilters} from "../../../core/constants/AdmittedStatus";
import UserSettings from "../../../core/constants/UserSettings";
import TextInput from '../../../shared/component/TextInput/TextInput';
import CheckBox from '../../../shared/component/CheckBox/CheckBox';
import Button from '../../../shared/component/button/Button';
import ComboBox from '../../../shared/component/ComboBox/ComboBox';
import {connect} from "react-redux";
import {default as _} from "../../../helpers/Translate";
import eventBus from "../../../core/utils/EventBus";
import SeparatorItem from "../list-row/SeparatorItem";
import Modal from "react-bootstrap/Modal";
import snippets from "../../../helpers/snippets";
import DatePicker from "../../../shared/component/DatePicker/DatePicker";
import config from "../../../config";
import FilterByDays from "../../../core/constants/FilterByDays";
import inpatientStatus from "../../../core/constants/InpatientStatus";
import BaseApi from "../../../core/api/BaseApi";
import {_loading} from "../../../actions/Loading";
import NavbarPart1 from "../Header/Navbar/NavbarPart1/NavbarPart1";
import moment from "jalali-moment";
import User from "../../../helpers/User";
import {getMenuStyle, getSymbol} from "../../../core/constants/ReportState";
import Barcode from "../BarcodeScanner/Barcode";
import user from "../../../helpers/User";

const baseApi = new BaseApi()

class ListHeader extends Component {

    constructor(props) {
        super(props);
        this.state = {
            device:this.props.device,
            scroll: this.props.scroll,
            language: this.props.language,
            openSettingModal: false,
            studyHeaderFilters: this.props.studyHeaderFilters,
            studyHeaderFiltersTemp: JSON.parse(JSON.stringify(this.props.studyHeaderFilters)), //this method of assigning make these two variable independent.
            studyHeaderFiltersRestore: false,
            calendarState: UserSettings.CAL_PERSIAN,
            checkboxAllState: this.props.checkAllState || false,
            comments: null,
            dateFrom: this.props.initialDatesBefore,
            dateTo: null,
            dateRangeName: FilterByDays.find(item => item.value === this.props.initialDatesBefore)?.name,
            selectedDate: null,
            description: null,
            dropdown: false,
            patientID: null,
            patientFirstName: null,
            patientLastName: null,
            modalities: [],
            modalityArr: Storage.getModalities(),
            reportStatus: [],
            report_text: null,
            reportStatesOptions: Object.entries(ReportStatusTranslatable).filter(item => item[0] !== "7" && item[0] !== "2")
                .map(([key, value]) => {
                // admitted reports (with status === 2) does not need icon and styles!
                return ({
                    id: key, value: key, text: value,
                    rawText: getSymbol(key).toUpperCase(),
                    rawStyles: getMenuStyle(key),
                });
            }),
            admittedStatusOptions: Object.entries(admittedFilters()).map(([key, value]) => {
                return ({
                    id: key, value: key, text: value
                })
            }),
            admittedStatus: [],
            inPatient: [],
            patientStateOptions: Object.entries(inpatientStatus).map(item => {
                return({id: item[0], value: item[0], text: item[1]});
            }),
            sex: null,
            sexSelected: "-1",
            sexOptions:[
                {
                    value: "-1",
                    text: "select_gender",
                    visibility: false
                },{
                    value: "1",
                    text: "male",
                    visibility: true
                },{
                    value: "0",
                    text: "female",
                    visibility: true
                }
            ],
            SearchInListOpenDiv: true,
            showSearchAsHeader: false,
            modals:{
                gender: false,
                report_status: false,
                inpatient_status: false,
                modalities: false,
                datePicker: false,
	            qr: false
            },
        };

        this.handleChangeSearch = this.handleChangeSearch.bind(this);
        this.setDataToParent = this.setDataToParent.bind(this);
        this.selectBoxAll = this.selectBoxAll.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.language !== this.props.language) {
            this.setState({language: this.props.language});
        }
        if (prevProps.device !== this.props.device) {
            this.setState({device: this.props.device});
        }
        if (prevProps.scroll !== this.props.scroll) {
            if (this.props.scroll === "up"){
                this.setState({showSearchAsHeader: false, SearchInListOpenDiv: true});
            } else if (this.props.scroll === "down"){
                this.setState({showSearchAsHeader: true, SearchInListOpenDiv: false});
            }
        }
        if (prevProps.initialDatesBefore !== this.props.initialDatesBefore) {
            this.setState({dateFrom: this.props.initialDatesBefore});
        }
        if (prevProps.studyHeaderFilters !== this.props.studyHeaderFilters) {
            this.setState({studyHeaderFilters: this.props.studyHeaderFilters});
        }
    }

    componentDidMount() {
        eventBus.on("ListHeaderReset", () => this.resetAllFilters())
        eventBus.on("ListHeaderFilter", data => this.handleProppedFilter(data))
    }

    componentWillUnmount() {
        eventBus.remove("ListHeaderReset", ()=>{})
        eventBus.remove("ListHeaderFilter", ()=>{})
    }

    handleProppedFilter = (data) =>{
        let sexSelected = data?.sex ?? "-1"
        let date = data?.date?.includes(`${_.init("->")}`)
            ? {dateFrom: moment.from(data?.date?.split(" -> ")[0], "fa", "jYYYY/jMM/jDD").locale("en").format("YYYY-MM-DD"), dateTo: moment.from(data?.date?.split(" -> ")[1], "fa", "jYYYY/jMM/jDD").locale("en").format("YYYY-MM-DD")}
            : {dateFrom: FilterByDays.filter(item => item.name === data?.date)[0]?.value, dateTo: null}
        this.setState({
            datepickerFrom: date.dateFrom,
            dateFrom: date.dateFrom,
            datepickerTo: date.dateTo,
            dateTo: date.dateTo,
            dateRangeName: date?.dateTo === null ? FilterByDays.find(item => item.name === data?.date)?.name : data?.date,
            comments: data?.comments,
            inPatient: data?.inpatient_status,
            modalities: data?.modalities,
            referringPhysiciansName: data?.referring_physicians_name,
            performingPhysiciansName: data?.performing_physicians_name,
            operatorsName: data?.operators_name,
            reportStatus: data?.report_statuses,
            report_text: data?.report_text,
            sex: data?.sex,
            sexSelected: sexSelected
        }, () => {
            this.setDataToParent(this.state);
            eventBus.dispatchEvent("DatePickerDatePropped", date)
        });
    }


    settingModalClose = () =>{
        this.setState({
            openSettingModal: false,
            studyHeaderFiltersTemp: JSON.parse(JSON.stringify(this.state.studyHeaderFilters))
        })
    }

    settingCheck = (event) =>{
        let obj = this.state.studyHeaderFiltersTemp
        obj[event.name].active = event.checked
        this.setState({studyHeaderFiltersTemp: obj}, ()=>{})
    }

    settingSave = () =>{
        this.props.dispatch(_loading(true))
        const e = this.state.studyHeaderFiltersTemp
        let keys = Object.entries(e).filter(([, value])=> value.active)
            .map(([key]) => key);
        let obj = {study_list_headers: Array(keys).join(',')}
        baseApi.fullFetch("login", "put", {data: obj, showMessageSuccess: true}).then(()=>{
            this.setState({
                openSettingModal: false,
                studyHeaderFilters: JSON.parse(JSON.stringify(this.state.studyHeaderFiltersTemp))
            }, ()=>{
                this.studyHeaderFiltersChanges(this.state.studyHeaderFilters)
            })
        })
    }

    studyHeaderFiltersChanges = (e) => {
        this.props.studyHeaderFiltersChanges(e)
    }

    settingModalReset = () => {
        Storage.studyHeaderFiltersReset()
        this.setState({
            studyHeaderFiltersTemp: Storage.studyHeaderFiltersGet(),
            studyHeaderFiltersRestore: true
        }, ()=>{
            setTimeout(() => {
                this.setState({studyHeaderFiltersRestore: false});
            }, 1000);
        })
    }

    resetAllFilters = () => {
        this.setState({
            checkboxAllState: false,
            comments: null,
            dateFrom: config.daysBeforePanel,
            dateTo: null,
            description: null,
            dropdown: false,
            inPatient: [],
            modalities: [],
            patientID: null,
            referringPhysiciansName: null,
            performingPhysiciansName: null,
            operatorsName: null,
            patientFirstName: null,
            patientLastName: null,
            reportStatus: [],
            report_text: null,
            selectedDate: null,
            sex: null,
            sexSelected: "-1",
        }, () => {
            this.props.resetFilters();
        });
    }

    refreshWithFilters = () => {
        this.setDataToParent(this.state);
    }

    handleChangeSearch(e) {
        this.setState({
            [e.target.name]: e.target.value
        }, () => {
            setTimeout(() => {
                this.setDataToParent(this.state);
            }, 500);
        })
    }

    setDataToParent(data) {
        // user debounce for wait three seconds
        this.props.handleData(data);
    }


    handleComboFilters = (key, value, singleState = false) => {
        let previousData = [...this.state[key]];

        if (value === "") {
            previousData = [];
        } else {
            let existence = previousData.find(item => item === value);

            if (existence) {
                if (singleState) {
                    previousData = [];
                } else {
                    previousData = previousData.filter(item => item !== value);
                }
            } else {
                if (singleState) {
                    previousData = [];
                    previousData.push(value);
                } else {
                    previousData.push(value);
                }
            }
        }
        this.setState({
            [key]: previousData
        }, () => {
            this.setDataToParent(this.state);
        });
    }

    handleSexFilter = (value) => {
        if (this.state.sex === value || value === "-1") {
            value = null;
        }
        this.handleCloseModal("gender", false)

        this.setState({
            sex: value,
            sexSelected: value === null ? "-1": value
        }, () => {
            this.setDataToParent(this.state);
        });
    }

    selectBoxAll() {
        this.setState({
            checkboxAllState: !this.state.checkboxAllState
        }, () => {
            this.props.handleCheckAll(this.state.checkboxAllState);
        });
    }

    desktopModeHeader = () =>{
        let modalities = [];
        this.state.modalityArr?.map(item => modalities.push({id: item.name, text: item.name, description: item.desc ?? item.name}));
        let studyHeaderFiltersActive = 3
        for (const key in this.state.studyHeaderFilters) {
            if (this.state.studyHeaderFilters[key]?.active === true) {
                studyHeaderFiltersActive++;
            }
        }
        return <>
            <thead className={"thead"}>
            <tr className="table-title">
                <th scope="col"> </th>
                <th scope="col"> </th>
                {Object.entries(this.state.studyHeaderFilters).map(([key, value]) => {
                    return value?.active && <th scope="col" key={key}><T token={key}/></th>
                })}
                <th scope="col"> </th>
            </tr>
            <tr className="table-header">
                <th>
                    <CheckBox handleChangeValue={this.selectBoxAll} checked={this.state.checkboxAllState} />
                </th>
                <th>
                    <div className="inline-them">
                        {User.canViewHeaderSettings() &&
                            <i className={'fa fa-light fa-gear customized-buttons'}
                               onClick={() => this.setState({openSettingModal: true})}
                               title={_.init("filter_setting", this.state.language)}/>}
                        {/*<i className={'fa fa-light fa-circle-question customized-buttons'}/>*/}
                        <i className={'fa fa-thin fa-refresh customized-buttons'} style={{color: colors['primary']}} onClick={this.refreshWithFilters}
                           title={_.init("reload_filters", this.state.language)}/>
                        <i className={'fa fa-thin fa-arrow-rotate-right customized-buttons'} style={{color: colors['redLight']}} onClick={this.resetAllFilters}
                           title={_.init("reset_filters", this.state.language)}/>
                    </div>
                </th>
                {this.state.studyHeaderFilters?.patient_id_or_request_number?.active &&
                    <th>
                        <TextInput name="patientID" defaultValue={this.state.patientID}
                                   handleChange={this.handleChangeSearch}/>
                    </th>}
                {this.state.studyHeaderFilters?.first_name?.active &&
                    <th>
                        <TextInput name="patientFirstName" defaultValue={this.state.patientFirstName}
                                   handleChange={this.handleChangeSearch}/>
                    </th>}
                {this.state.studyHeaderFilters?.last_name?.active &&
                    <th>
                        <TextInput name="patientLastName" defaultValue={this.state.patientLastName}
                                   handleChange={this.handleChangeSearch}/>
                    </th>}
                {this.state.studyHeaderFilters?.sex?.active &&
                    <th title={_.init("sex", this.state.language)}>
                        <div className="inline-them sex">
                            <Button customClasses="margin-2px" size="small" mode="gray-new"
                                    selected={this.state.sex === '1'}
                                    onClick={() => {
                                        this.handleSexFilter('1')
                                    }}
                            >
                                <i className={'fal fa-male customize-font'}/>
                            </Button>
                            <Button customClasses="margin-2px" size="small" mode="gray-new"
                                    selected={this.state.sex === '0'}
                                    onClick={() => {
                                        this.handleSexFilter('0')
                                    }}
                            >
                                <i className={'fal fa-female customize-font'}/>
                            </Button>
                        </div>
                    </th>}

                {this.state.studyHeaderFilters?.birth_date?.active && <th> </th>}
                {this.state.studyHeaderFilters?.age?.active && <th> </th>}
                {this.state.studyHeaderFilters?.date?.active && <th> </th>}
                {this.state.studyHeaderFilters?.study_reason?.active && <th> </th>}
                {this.state.studyHeaderFilters?.modality?.active &&
                    <th>
                        <ComboBox type="checkbox"
                                  itemsDir="ltr"
                                  name="modalities"
                                  dropDownTitle="chose_modalities"
                                  values={modalities}
                                  onChangeValue={this.handleComboFilters}
                                  selecteds={this.state.modalities}
                                  tooltip={_.init("modality", this.state.language)}/>
                    </th>}
                {this.state.studyHeaderFilters?.source_application_entity?.active && <th> </th>}
                {this.state.studyHeaderFilters?.patient_status?.active &&
                    <th>
                        <ComboBox type="checkbox"
                                  itemsDir="ltr"
                                  name="inPatient"
                                  dropDownTitle="inpatient_status"
                                  values={this.state.patientStateOptions}
                                  onChangeValue={this.handleComboFilters}
                                  selecteds={this.state.inPatient}
                                  singleChoose={false}/>
                    </th>}
                {this.state.studyHeaderFilters?.comments?.active &&
                    <th title={_.init("filter_comments_help", this.state.language)}>
                        <TextInput name="comments" defaultValue={this.state.comments}
                                   handleChange={this.handleChangeSearch}/>
                    </th>}
                {this.state.studyHeaderFilters?.report_type?.active &&
                    <th title={_.init("report_type", this.state.language)}>
                        <ComboBox type="checkbox"
                                  itemsDir="ltr"
                                  dropDownTitle="report_statuses"
                                  name="reportStatus"
                                  values={this.state.reportStatesOptions}
                                  onChangeValue={this.handleComboFilters}
                                  selecteds={this.state.reportStatus}
                        />
                    </th>}
                {this.state.studyHeaderFilters?.admitted_status?.active &&
                    <th title={_.init("admitted_status", this.state.language)}>
                        <ComboBox type="checkbox"
                                  singleChoose={true}
                                  itemsDir="ltr"
                                  dropDownTitle="admitted_status"
                                  name="admittedStatus"
                                  values={this.state.admittedStatusOptions}
                                  onChangeValue={this.handleComboFilters}
                                  selecteds={this.state.admittedStatus}
                        />
                    </th>}
                {this.state.studyHeaderFilters?.report?.active &&
                    <th title={_.init("report", this.state.language)}>
                        <TextInput name="report_text" defaultValue={this.state.report_text}
                                   handleChange={this.handleChangeSearch}/>

                    </th>}
                {this.state.studyHeaderFilters?.referring_physicians_name?.active &&
                    <th>
                        <TextInput name="referringPhysiciansName" defaultValue={this.state.referringPhysiciansName}
                                   handleChange={this.handleChangeSearch}/>
                    </th>}
                {this.state.studyHeaderFilters?.performing_physicians_name?.active &&
                    <th>
                        <TextInput name="performingPhysiciansName" defaultValue={this.state.performingPhysiciansName}
                                   handleChange={this.handleChangeSearch}/>
                    </th>}
                {this.state.studyHeaderFilters?.operators_name?.active &&
                    <th>
                        <TextInput name="operatorsName" defaultValue={this.state.operatorsName}
                                   handleChange={this.handleChangeSearch}/>
                    </th>}
                {this.state.studyHeaderFilters?.file_size?.active && <th></th>}
                <th></th>
            </tr>
            <><SeparatorItem cols={studyHeaderFiltersActive}/><SeparatorItem cols={studyHeaderFiltersActive}/></>
            </thead>


            <Modal dialogClassName={"studyHeaderFilters__modal"} show={this.state.openSettingModal} onHide={() => this.settingModalClose()} >
                <div className={'imodal'}>
                    <div className={'imodal__header'}>
                        <div className={'imodal__close'}
                             onClick={() => this.settingModalClose()}
                        ><i className={'fal fa-times-circle'}/></div>
                        <div className={'imodal__title'}><T token={'filter_setting'}/></div>
                        <div></div>
                    </div>
                    <div className={'imodal__body'}>
                        <div className={"studyHeaderFilters__setting"}>
                            {Object.entries(this.state.studyHeaderFiltersTemp).map(([key, value]) => {
                                return <CheckBox type="complex"
                                                 disableMainLabel={true}
                                                 name={key}
                                                 key={key}
                                                 labelText={key}
                                                 handleChangeValue={this.settingCheck}
                                                 checked={value.active}
                                                 icon={"fal fa-info-circle"}
                                                 tooltipWithIcon={_.init(value.tooltip, this.state.language)}
                                                 transparent
                                />
                            })}
                        </div>
                        <div className={`studyHeaderFilters__resetToDefaults ${this.state.studyHeaderFiltersRestore ? "rotated" : ""}`}>
                            <div className={'reset__btn'} onClick={() => this.settingModalReset()}>
                                <i className={'fal fa-arrow-rotate-right'} />
                            </div>
                        </div>
                    </div>
                    <div className={'imodal__action'}>
                        <div className={'imodal__btn imodal__btn--primary'}
                             onClick={() => this.settingSave()}><T token={'save'}/>
                        </div>
                        <div className={'imodal__btn imodal__btn--secondary'}
                             onClick={() => this.settingModalClose()}><T token={'close'}/>
                        </div>
                    </div>
                </div>
            </Modal>
            </>
    }

    cancelFilters = () => {
        this.setState({SearchInListOpenDiv: false,
            dateRangeName: FilterByDays.find(item => item.value === config.daysBeforePanel)?.name}, () => {
            this.resetAllFilters()
        })

    }

    searchByFilters = () => {
        this.setState((prevState) => ({
            SearchInListOpenDiv: !prevState.SearchInListOpenDiv
        }), ()=>{
            if (this.state.showSearchAsHeader){
                document.getElementById('list__helper__container').scrollTop = 0
            }
            // this.props.dispatch(handleScrollingDown())
        })
    }

    mobileModeHeader = () =>{
        return <div className={`mobileModeHeader ${ this.state.showSearchAsHeader ? "asHeader" : ""}`} >
            <div className={`mobileModeHeader__header `}>
                <div className={"mobileModeHeader__header__right"}>

                </div>
                <div className={"mobileModeHeader__header__left"}>
                    <Button className={"reload"} customClasses="margin-2px" size="small" mode="gray-new"
                            onClick={() => this.refreshWithFilters()}
                            selected={true}
                            tooltip={_.init("reload_filters", this.state.language)}
                    >
                        <T token={"reload_filters"} /> <i className="fa fa-refresh" />
                    </Button>

                    <Button className={"cancel_search"} customClasses="margin-2px" size="small" mode="gray-new"
                            onClick={() => this.cancelFilters()}
                            selected={true}
                            tooltip={_.init("cancel_button_tooltip", this.state.language)}
                    >
                        <T token={"cancel_filters"} /> <i className="fa fa-close" />
                    </Button>

                    <Button className={"search"} customClasses="margin-2px" size="small" mode="gray-new"
                            onClick={() => this.searchByFilters()}
                            selected={true}
                            tooltip={_.init("search_button_tooltip", this.state.language)}
                    >
                        <T token={"search_in_list"} /> <i className="fa fa-search" />
                    </Button>
                </div>
            </div>
            { this.state.SearchInListOpenDiv && this.mobileModeFilters() }
        </div>
    }

    handleCloseModal = (modal, removeFilters = false) =>{
        let modals = this.state.modals
        modals[modal] = false

        if (removeFilters){
            switch (modal) {
                case "gender":
                    this.setState({modals: modals,  sexSelected: "-1"}, ()=>{this.handleSexFilter(this.state.sexSelected)})
                    break;
                case "inPatient":
                    this.setState({modals: modals,  inPatient: []}, ()=>{this.setDataToParent(this.state)})
                    break;
                case "modalities":
                    this.setState({modals: modals,  modalities: []}, ()=>{this.setDataToParent(this.state)})
                    break;
                case "report_status":
                    this.setState({modals: modals,  reportStatus: []}, ()=>{this.setDataToParent(this.state)})
                    break;
                case "datePicker":
                    this.setState({modals: modals,  dateFrom: config.daysBeforePanel, datepickerFrom: config.daysBeforePanel,
                            dateTo: null, datepickerTo: null, dateRangeName: FilterByDays.find(item => item.value === config.daysBeforePanel)?.name},
                        ()=>{this.setDataToParent(this.state)})
                    break;
                case "qr":
                    this.handleCloseModal('qr')
                    break;
                default:
                    console.error("what is this modal")
            }
        } else {
            this.setState({modals: modals})
        }
    }

    handleOpenModal = (modal) =>{
        let modals = this.state.modals
        modals[modal] = true
        this.setState({modals: modals})
    }

    handleDateChange = (isRange, e) => {
        if (isRange === false && this.state.dateRangeName !== e ){
            this.setState({dateRangeName: e, dateFrom: FilterByDays.find(item => item.name === e)?.value, dateTo: null})
        } else if (isRange === true && e.dateTo !== null ) {
            let from = snippets.datetime(e.datepickerFrom)
            let to = snippets.datetime(e.datepickerTo)
            let dateSTR = `${from} -> ${to}`
            this.setState({dateRangeName: dateSTR, dateFrom: e.datepickerFrom, dateTo: e.datepickerTo})
            this.setDataToParent(e)
        }
        this.handleCloseModal("datePicker")
    }
	
	barcodeScanner = () => {
		this.handleOpenModal('qr')
	}
	
	qrScanner = (res) => {
		if (res) {
			let obj = {target: { name: 'patientID', value: res}}
			this.handleChangeSearch(obj)
			this.handleCloseModal('qr')
		}
	}

    mobileModeFilters = () => {
        let genderButtonText = _.init(this.state.sexOptions.find(item => item.value === this.state.sexSelected)?.text)

        let modalityButtonText = snippets.isObjectEmpty(this.state.modalities) ?
            "choose_modality"
            : this.state.modalities.map((item)=>{ return item} ).join(`${_.init(",")} `) ;

        let inPatientButtonText = snippets.isObjectEmpty(this.state.inPatient) ?
            "inpatient_status"
            : this.state.inPatient.map((item)=>{ return _.init(inpatientStatus[item], this.state.language)} ).join(`${_.init(",")} `) ;

        let reportStatesButtonText = snippets.isObjectEmpty(this.state.reportStatus) ?
            "report_type"
            : this.state.reportStatus.map((item)=>{ return (_.init(ReportStatusTranslatable[item], this.state.language))} ).join(`${_.init(",")} `) ;

        let dateButtonText = snippets.isObjectEmpty(this.state.dateFrom) ?
            "interval"
            : this.state.dateRangeName ;
        let rangeSelected =  !snippets.isObjectEmpty(this.state.dateFrom)
        let dateObject = {"dateFrom": this.state.dateFrom, "dateTo": this.state.dateTo, filterName: this.state.dateRangeName}


        return <div className={"table_mobile_header thead"} >
            <div className={"class-1"}>
                <div className={"class-1__item"}>
                    <TextInput name="patientID" defaultValue={this.state.patientID} handleChange={this.handleChangeSearch} placeholder="patient_id" />
                    <i className={'fa fa-barcode-read'} onClick={this.barcodeScanner}/>
                </div>
                <div className={"class-1__item"}>
                    <TextInput name="patientFirstName" defaultValue={this.state.patientFirstName} handleChange={this.handleChangeSearch} placeholder="first_name"/>
                </div>
                <div className={"class-1__item"}>
                    <TextInput name="patientLastName" defaultValue={this.state.patientLastName} handleChange={this.handleChangeSearch} placeholder="last_name"/>
                </div>
                <div className={"class-1__item"}>
                    <TextInput name="comments" defaultValue={this.state.comments} handleChange={this.handleChangeSearch} placeholder="comments"/>
                </div>
            </div>

            <div className={"class-2"}>
                <Button customClasses="margin-2px" size="small" mode="gray-new"
                        onClick={() => {this.handleOpenModal('gender')}}
                        selected={ this.state.sexSelected !== "-1" }
                        tooltip={`${genderButtonText}`}
                >
                    <T token={genderButtonText} />
                </Button>

                <Button customClasses="margin-2px" size="small" mode="gray-new"
                        onClick={() => {this.handleOpenModal('inPatient')}}
                        selected={ !snippets.isObjectEmpty(this.state.inPatient) }
                        tooltip={`${_.init(inPatientButtonText, this.state.language)}`}
                >
                    <T token={inPatientButtonText} />
                </Button>

                <Button customClasses="margin-2px" size="small" mode="gray-new"
                        onClick={() => {this.handleOpenModal('modalities')}}
                        selected={ !snippets.isObjectEmpty(this.state.modalities) }
                        tooltip={`${_.init(modalityButtonText, this.state.language)}`}
                >
                    <T token={modalityButtonText} />
                </Button>

                <Button customClasses="margin-2px" size="small" mode="gray-new"
                        onClick={() => {this.handleOpenModal('report_status')}}
                        selected={ !snippets.isObjectEmpty(this.state.reportStatus) }
                        tooltip={`${_.init(reportStatesButtonText, this.state.language)}`}
                >
                    <T token={reportStatesButtonText} />
                </Button>

                <Button customClasses="margin-2px" size="small" mode="gray-new"
                        onClick={() => {this.handleOpenModal('datePicker')}}
                        selected={rangeSelected}
                        tooltip={`${_.init(dateButtonText, this.state.language)}`}
                >
                    <T token={dateButtonText} />
                </Button>
            </div>

            <div className={"class-3"}>
                <NavbarPart1 />
            </div>

            <Modal show={this.state.modals.gender} onHide={() => this.handleCloseModal("gender")}>
                <div className={'imodal gender'}>
                    <div className={'imodal__header'}>
                        <div className={'imodal__close'}
                             onClick={() => this.handleCloseModal('gender')}
                        ><i className={'fa fa-light fa-times-circle'}/></div>
                        <div className={'imodal__title'}><T token={'select_gender'}/></div>
                    </div>
                    <div className={'imodal__body'}>
                        <div className={"modality_select_buttons"}>
                            {this.state.sexOptions.map((item, index) =>
                                item.visibility && <Button customClasses="margin-2px" size="small" mode="gray-new" buttonText={item.text} key={index}
                                        onClick={()=>this.handleSexFilter(item.value)}
                                        selected={this.state.sexSelected === `${item.value}`}
                                />
                            )}
                        </div>
                    </div>
                    <div className={'imodal__action'}>
                        <div className={'imodal__btn imodal__btn--primary'}
                             onClick={() => this.handleCloseModal("gender")}><T token={'ok'}/>
                        </div><div className={'imodal__btn imodal__btn--secondary'}
                             onClick={() => this.handleCloseModal("gender", true)}><T token={'select_both'}/>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal show={this.state.modals.inPatient} onHide={() => this.handleCloseModal("inPatient")}>
                <div className={'imodal'}>
                    <div className={'imodal__header'}>
                        <div className={'imodal__close'}
                             onClick={() => this.handleCloseModal('inPatient')}
                        ><i className={'fa fa-light fa-times-circle'}/></div>
                        <div className={'imodal__title'}><T token={'inpatient_status'}/></div>
                    </div>
                    <div className={'imodal__body'}>
                        <div className={"modality_select_buttons"}>
                            {this.state.patientStateOptions.map((item, index) =>
                                <Button customClasses="margin-2px" size="small" mode="gray-new" buttonText={item.text} key={index}
                                        onClick={()=>this.handleComboFilters("inPatient", item.value, false)}
                                        selected={this.state.inPatient?.includes(item.value)}
                                />
                            )}
                        </div>
                    </div>
                    <div className={'imodal__action'}>
                        <div className={'imodal__btn imodal__btn--primary'}
                             onClick={() => this.handleCloseModal("inPatient")}><T token={'ok'}/>
                        </div><div className={'imodal__btn imodal__btn--secondary'}
                                   onClick={() => this.handleCloseModal("inPatient", true)}><T token={'remove_selected'}/>
                    </div>
                    </div>
                </div>
            </Modal>

            <Modal show={this.state.modals.modalities} onHide={() => this.handleCloseModal("modalities")}>
                <div className={'imodal'}>
                    <div className={'imodal__header'}>
                        <div className={'imodal__close'}
                             onClick={() => this.handleCloseModal('modalities')}
                        ><i className={'fa fa-light fa-times-circle'}/></div>
                        <div className={'imodal__title'}><T token={'choose_modality'}/></div>
                    </div>
                    <div className={'imodal__body'}>
                        <div className={"modality_select_buttons"}>
                            {this.state.modalityArr?.map((item, index) =>
                                <Button customClasses="margin-2px" size="small" mode="gray-new" buttonText={item.name} key={index}
                                        onClick={()=>this.handleComboFilters("modalities", item.name, false)}
                                        selected={this.state.modalities?.includes(item.name)}
                                />
                            )}
                        </div>
                    </div>
                    <div className={'imodal__action'}>
                        <div className={'imodal__btn imodal__btn--primary'}
                             onClick={() => this.handleCloseModal("modalities")}><T token={'ok'}/>
                        </div><div className={'imodal__btn imodal__btn--secondary'}
                             onClick={() => this.handleCloseModal("modalities", true)}><T token={'remove_selected'}/>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal show={this.state.modals.report_status} onHide={() => this.handleCloseModal("report_status")}>
                <div className={'imodal'}>
                    <div className={'imodal__header'}>
                        <div className={'imodal__close'}
                             onClick={() => this.handleCloseModal('report_status')}
                        ><i className={'fa fa-light fa-times-circle'}/></div>
                        <div className={'imodal__title'}><T token={'report_type'}/></div>
                    </div>
                    <div className={'imodal__body'}>
                        <div className={"report_status_select_buttons"}>
                            {this.state.reportStatesOptions.map((item, index) =>
                                <Button customClasses="margin-2px" size="small" mode="gray-new" buttonText={item.text} key={index}
                                        onClick={()=>this.handleComboFilters("reportStatus", item.value, false)}
                                        selected={this.state.reportStatus?.includes(item.value)}
                                />
                            )}
                        </div>
                    </div>
                    <div className={'imodal__action'}>
                        <div className={'imodal__btn imodal__btn--primary'}
                             onClick={() => this.handleCloseModal("report_status")}><T token={'ok'}/>
                        </div><div className={'imodal__btn imodal__btn--secondary'}
                             onClick={() => this.handleCloseModal("report_status", true)}><T token={'remove_selected'}/>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal show={this.state.modals.datePicker} onHide={() => this.handleCloseModal("datePicker")}>
                {/*selectedDate*/}
                <div className={'imodal'}>
                    <div className={'imodal__header'}>
                        <div className={'imodal__close'}
                             onClick={() => this.handleCloseModal('datePicker')}
                        ><i className={'fa fa-light fa-times-circle'}/></div>
                        <div className={'imodal__title'}><T token={'range_date'}/></div>
                    </div>
                    <div className={'imodal__body'}>
                        <div className={"datePicker_select_fast"}>
                            <DatePicker type="mobile" onDateChanged={this.handleDateChange} defaultValue={dateObject} />
                        </div>
                    </div>
                    <div className={'imodal__action'}>
                        <div className={'imodal__btn imodal__btn--secondary'}
                             onClick={() => this.handleCloseModal("datePicker", true)}><T token={'default_range_date'}/>
                        </div>
                    </div>
                </div>
            </Modal>
	        
	        <Modal show={this.state.modals.qr} onHide={() => this.handleCloseModal("qr")}>
                <div className={'imodal'}>
                    <div className={'imodal__header'}>
                        <div className={'imodal__close'}
                             onClick={() => this.handleCloseModal('qr')}
                        ><i className={'fa fa-light fa-times-circle'}/></div>
                        <div className={'imodal__title'}><T token={'barcode_scan'}/></div>
                    </div>
                    <div className={'imodal__body'}>
                        <div className={"qr_scanner"}>
                            <Barcode onChange={this.qrScanner} />
                        </div>
                    </div>
                    <div className={'imodal__action'}>
                        <div className={'imodal__btn imodal__btn--secondary'}
                             onClick={() => this.handleCloseModal("qr", true)}><T token={'close'}/>
                        </div>
                    </div>
                </div>
            </Modal>

        </div>
    }

    render() {
        return this.state.device === "desktop" ? this.desktopModeHeader() : this.mobileModeHeader()
    }
}

const mapStateToProps = state => {
    const language = state.LangReducer.language;
    const device = state.DeviceModeReducer.mode;
    const scroll = state.panelScrollingReducer.scroll_direction;
    return {language, device, scroll};
}

export default connect(mapStateToProps)(ListHeader);